import styled from "styled-components";
import { GiFiles } from "react-icons/gi";
import { useComparisonState } from "../hooks/useComparisonState";
import { useDispatch } from "react-redux";
import { filterOperations } from "../../../state/features/filters";

const ExitComparisonButton = () => {
  const { exit } = useComparisonState();
  const dispatch = useDispatch();

  const handleExit = () => {
    dispatch(filterOperations.clearWidgetFilter());
    exit();
  };

  return (
    <StyledButton onClick={handleExit}>
      <GiFiles fontSize="20px" />
      <span>EXIT COMPARISON</span>
    </StyledButton>
  );
};

export default ExitComparisonButton;

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background: #c62828;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #b71c1c;
  }

  svg path {
    stroke: #fff;
  }
`;
